import { loaderSlice } from '../store/slices/loaderSlice';

export const showLoader = loaderSlice.reducer;
